import { ElLoading, ElMessage } from 'element-plus'
import router from "./router";
import { setDocumentTitle } from "./utils/tools";
import { getLsHasLogin, getLsUserInfo, setLsUserInfo, setLsPermission } from "./core/storage/ls";
import {
  setGlobalDefaultOpenedMenus,
  setGlobalDefaultActiveMenu,
  getGlobalBreadcrumbs,
} from "./core/global-data";
import generatePermission from "./core/permission";
// import { createWs } from './core/ws'
import { apiWorkerPermission } from "./api/personnel/user";
import { setGlobalData } from '@/core/global-data'
import { $t } from '@/i18n'
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';


const whiteList = ["login", "secret-login"]; // no redirect whitelist
const loginRoutePath = "/login";

let hasGetPermission = false;

NProgress.configure({
  showSpinner: false,
  color: 'red'
})

router.beforeEach(async (to) => {
  NProgress.start();
  to.meta &&
    typeof to.meta.title !== "undefined" &&
    setDocumentTitle( $t(to.meta.title));
  if (getLsHasLogin()) {
    if (whiteList.includes(to.name)) {
      return true;
    }
    // 超管专属路由：非超管禁止访问
    if (to.meta?.root && Number((getLsUserInfo() || {}).root) !== 1) {
      return '/home'
    }
    if (!hasGetPermission) {
      const loadingInstance = ElLoading.service({
        fullscreen: true,
      });
      const { result, error } = await apiWorkerPermission();
      setTimeout(() => {
        loadingInstance.close();
      }, 300);
      if (result) {
        hasGetPermission = true;
        if(result.data.mct_type === 2) {
          result.data.modules = [
            'SUPER_PARTNER',
            'SUPER_PARTNER_COMMISSION_INCOME',
            'SUPER_PARTNER_COMMISSION_EXPENDITURE',
            'SUPER_PARTNER_SETTLE_ACCOUNTS',
            'SUPER_PARTNER_PARTNER_MANAGER',
            'SETTLEMENT_CENTER',
            'SETTLEMENT_CENTER_DETAIL',
            'SETTLEMENT_CENTER_TRADING_DETAIL',
            'SETTLEMENT_CENTER_ACCOUNT_DETAIL',
            'SETTLEMENT_CENTER_ACCOUNT_DETAIL_BTN',
            'SETTLEMENT_CENTER_USE',
            'SETTLEMENT_CENTER_CONFIG',
            'SETTLEMENT_CENTER_MANAGER'
          ]
        }
        setLsUserInfo(result.data)
        setLsPermission(result.data.modules);
        setGlobalData('currency_code', result.data.currency_code || 'USD'); // 交易币种
        setGlobalData('country_code', result.data.country_code || 'US'); // 产地
        // createWs();
        generatePermission();
        return {
          ...to,
        };
      }
      if (error) {
        return loginRoutePath;
      }
    }
    return true;
  } else {
    if (whiteList.includes(to.name)) {
      // 在免登录白名单，直接进入
      return true;
    }
    return loginRoutePath;
  }
});

router.afterEach((to) => {
  // console.log(to,'to')
  const arr = to.matched.filter(
    (item) => item.name !== "index" && item.meta.showInBreadcrumb !== false
  );
  // console.log(arr,'arr')
  if (arr.length<=2) {
    setGlobalDefaultOpenedMenus([arr[0].path]);
    setGlobalDefaultActiveMenu(arr.at(-1).path);
  }else{
    setGlobalDefaultOpenedMenus([arr[0].path]);
    setGlobalDefaultActiveMenu(arr[1].path);
  }
  const breadcrumbs = getGlobalBreadcrumbs();
  breadcrumbs.splice(0, breadcrumbs.length, ...arr);
  NProgress.done();
});

// 点击菜单时，捕捉报错，刷新页面
router.onError(error => {
  if (error.message.includes("Failed to fetch dynamically imported module")) {
    // reload()：类似于点击浏览器上的刷新页面按钮
    ElMessage.info($t('common.newVersion'))
    setTimeout(() => {
      window.location.reload(true);
      ElMessage.success($t('common.newVersionSuccess'))
    }, 300);
  }
});